export const statusColorsCss = {
	active: {
		color: 'var(--bs-purple-600)',
		bg: 'var(--bs-purple-100)',
	},
	inactive: {
		color: 'var(--bs-gray-900)',
		bg: 'var(--bs-gray-200)',
	},
	info: {
		color: 'var(--bs-cyan-800)',
		bg: 'var(--bs-cyan-100)',
	},
	neutral: {
		color: 'var(--bs-indigo-600)',
		bg: 'var(--bs-indigo-100)',
	},
	success: {
		color: 'var(--bs-teal-800)',
		bg: 'var(--bs-teal-200)',
	},
	warning: {
		color: 'var(--bs-yellow-900)',
		bg: 'var(--bs-yellow-200)',
	},
	pending: {
		color: 'var(--bs-orange-800)',
		bg: 'var(--bs-orange-200)',
	},
	danger: {
		color: 'var(--bs-danger-800)',
		bg: 'var(--bs-danger-200)',
	},
	primary: {
		color: 'var(--bs-blue-700)',
		bg: 'var(--bs-blue-200)',
	},
	new: {
		color: 'var(--bs-pink-700)',
		bg: 'var(--bs-pink-100)',
	},
	fuchsia: {
		color: 'var(--bs-pink-700)',
		bg: 'var(--bs-pink-200)',
	},
	lavender: {
		color: 'var(--bs-purple-600)',
		bg: 'var(--bs-purple-100)',
	},
	mint: {
		color: 'var(--bs-teal-800)',
		bg: 'var(--bs-teal-100)',
	},
	olive: {
		color: 'var(--bs-green-800)',
		bg: 'var(--bs-green-100)',
	},
	gold: {
		color: 'var(--bs-yellow-700)',
		bg: 'var(--bs-yellow-100)',
	},
	peach: {
		color: 'var(--bs-orange-700)',
		bg: 'var(--bs-orange-100)',
	},
	red: {
		color: 'var(--bs-red-500)',
		bg: 'var(--bs-orange-100)',
	},
	sold: {
		color: 'var(--bs-form-invalid-color)',
		bg: 'var(--bs-danger-bg-subtle)',
	},
	green: {
		color: 'var(--bay-deep-green)',
		bg: 'var(--bs-green-100)',
	},
	error: {
		color: 'var(--bs-red)',
		bg: 'var(--bs-danger-bg-subtle)',
	}
};

export default statusColorsCss;
